import { yupResolver } from "@hookform/resolvers/yup";
import { EmailParameterApi } from "api";
import { PaziaFromQuill } from "components/atoms/PaziaQuill/PaziaFromQuill";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { PaziaButton, PaziaInput } from "components/atoms";

const schema = yup
  .object({
    name: yup.string().required(),
    value: yup.string().required(),
  })
  .required();

export type EditParameterFormValues = yup.InferType<typeof schema>;

interface EditParameterFormProps {
  parameter: EmailParameterApi;
  onSubmit: (data: EditParameterFormValues) => void;
  onDelete: () => void;
}
export const EditParameterForm = ({ parameter, onSubmit, onDelete }: EditParameterFormProps) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    values: {
      name: parameter.name,
      value: parameter.value,
    },
  });

  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
        <div className="flex flex-col gap-4">
          <div>Edycja parametru</div>
          <div className="flex flex-col gap-2">
            <PaziaInput label="Nazwa" name="name" disabled required />
            <PaziaFromQuill label="Wartość" name="value" required />
          </div>
          <div className="flex justify-between">
            <PaziaButton type="danger" title="Usuń" onClick={onDelete} btnType="button" />
            <PaziaButton type="success" title="Zapisz" />
          </div>
        </div>
      </form>
    </FormProvider>
  );
};
